import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 text-white py-12 px-4 border-t border-white/10" data-id="element-94">
      <div className="max-w-[720px] mx-auto text-center flex flex-col items-center gap-6" data-id="element-95">
        <div data-id="element-96">
          <h3 className="text-lg font-bold text-gold mb-2" data-id="element-97">
            💰 El Costo de No Hacer Nada™
          </h3>
          <p className="text-[14px] text-white/60 max-w-[500px] leading-[1.6]" data-id="element-98">
            El sistema N°1 para ordenar tus finanzas, ahorrar e invertir de
            forma progresiva, práctica y adaptada a la vida real en Argentina.
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[13px] text-white/50" data-id="element-99">
          <a href="mailto:contacto@fidelate.com" className="hover:text-white transition-colors" data-id="element-100">
            📧 contacto@fidelate.com
          </a>
          <span data-id="element-101">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-102">
            📱 @fidelate
          </a>
          <span data-id="element-103">·</span>
          <a href="https://fidelate.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-104">
            🌐 fidelate.com
          </a>
        </div>

        <div className="w-full h-px bg-white/10 my-2" data-id="element-105"></div>

        <p className="text-[12px] text-white/40" data-id="element-106">
          © Fidelate.com™ 2026 — Todos los derechos reservados.
        </p>

        <p className="text-[14px] text-white/70 italic font-medium mt-2" data-id="element-107">
          💰 "El costo de no hacer nada siempre es más alto que el costo de
          empezar."
        </p>
      </div>
    </footer>;
}